import { Condition, conditionSchema } from "@/models/ConditionModel.ts";

import { ApiDataSourceSpec, apiDataSource } from "../datasource/ApiDatasource";

export class ConditionRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getCondition = (patientId: string): Promise<Condition> => {
    return this.datasource.get(`/practitioner/condition/${patientId}/`, conditionSchema);
  };
}
